<span *ngIf="employee && employee.check_partner_message">
  <span
    class="color-red-dark text-ellipsis"
    *ngIf="employee.personnel_number && employee.personnel_number.length >= 12"
    [ngbPopover]="partnerCodeErrorMessagePopover"
    triggers="mouseenter:mouseleave"
    placement="bottom-right"
  >
    {{ employee.personnel_number }}
  </span>
  <span
    class="color-red-dark"
    *ngIf="employee.personnel_number && employee.personnel_number.length < 12"
    [ngbPopover]="partnerCodeErrorMessagePopover"
    triggers="mouseenter:mouseleave"
    placement="bottom-right"
  >
    {{ employee.personnel_number }}
  </span>
</span>

<span *ngIf="employee && !employee.check_partner_message">
  <span
    class="text-ellipsis"
    *ngIf="employee.personnel_number && employee.personnel_number.length >= 12"
    [ngbPopover]="partnerCodePopover"
    triggers="mouseenter:mouseleave"
    placement="bottom-right"
  >
    {{ employee.personnel_number }}
  </span>
  <span *ngIf="employee.personnel_number && employee.personnel_number.length < 12">
    {{ employee.personnel_number }}
  </span>
</span>

<ng-template #partnerCodeErrorMessagePopover>
  <div class="w-320 color-red-dark">
    {{ employee?.check_partner_message }}
  </div>
</ng-template>

<ng-template #partnerCodePopover>
  {{ employee?.personnel_number }}
</ng-template>